import React from 'react';
import './bookJacket.less';
import ReactImageFallback from "react-image-fallback";
const bookJacketNotFoundUrl = "https://imageserver.ebscohost.com/embimages/novelplus/2008/novjackets/empty/medium/empty.jpg";
const titleJacketClassName ="title-book-jacket";
const detailsJacketClassName ="details-book-jacket";
const similarTitlesJacketClassName ="similar-book-jacket";

const SimilarTitleBookJacket = ({ image, title}) =>
	<ReactImageFallback className={similarTitlesJacketClassName} src={image} alt={title} title={title} fallbackImage={bookJacketNotFoundUrl}/>;


const TitleBookJacket = ({ image, title }) =>
<ReactImageFallback className={titleJacketClassName} src={image} alt={title} title={title} fallbackImage={bookJacketNotFoundUrl}/>;

const DetailsBookJacket = ({ image, title }) =>
<ReactImageFallback className={detailsJacketClassName} src={image} alt={title} title={title} fallbackImage={bookJacketNotFoundUrl}/>;

export {SimilarTitleBookJacket, TitleBookJacket, DetailsBookJacket};



// WEBPACK FOOTER //
// ./src/react/views/bookJacket/BookJacket.jsx